/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { classNames } from '../utils/UNSAFE_classNames';
import { messageTimestampStyles } from './themes/MessageStyles.css';
import { MessageVariant } from './Message.types';
import { formatTimestamp } from './MessageFormattingUtils';

/**
 * Props for the Timestamp component
 */
type Props = {
  /**
   * The timestamp to show in ISO format
   */
  value: string;

  /**
   * Style variant
   */
  variant?: MessageVariant;
};

/**
 * Timestamp Component for rendering timestamp in Message
 */
function MessageTimestamp({ value, variant = 'banner' }: Props) {
  // If detail content is rendered, then wrap it in a div with specified style classes
  // TODO: JET-48715 - remove marker classes
  // Right now, oj-message-banner component uses this for unit tests and has no alternate way for
  // testing. This will need to be removed as we work on oj-c-message-banner.
  // TODO:  Refactor to utilize useComponentTheme and multiVariantStyles.

  const markerClassForTests = 'oj-c-messagebanner-timestamp';
  const classes = classNames([
    variant === 'banner' && markerClassForTests,
    messageTimestampStyles[variant]
  ]);

  // Otherwise, render the timestamp
  const formattedTimestamp = formatTimestamp(value as string);
  return <div class={classes}>{formattedTimestamp}</div>;
}

export { MessageTimestamp };
